import React, { useState } from "react";
import CourseFile from "../../CourseFileUpload";
import TextEditor from "./TextEditor";
import { useLocation } from "react-router-dom";

export const CourseSection = ({
  current,
  index,
  section,
  handleInputChange,
  handleEditorStateChange,
  courseFile,
  removeFormFields,
  history,
  location1,
  // syllabusId,
  // syllabusName,
  syllabusList = [],
  setSelectedSyllabus,
  selectedSyllabus
}) => {

  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  const handleAddCourseMaterial = (event) => {
    event.preventDefault();
    setIsActive((state) => !state);
  };

  return (
    <div className="course-section" key={index}>
      <div className="section-introduction">

        {/* {syllabusList && (
          <div className="form-inline section-description mb-3">
            <label>Syllabus</label>
            <select
              className="form-control !mt-2"
              value={selectedSyllabus?.id || ""}
              onChange={(e) => {
                const selected = syllabusList.find(
                  (item) => item?.id === parseInt(e.target.value)
                );
                setSelectedSyllabus({
                  id: selected?.id,
                  name: selected?.name
                })
                handleInputChange(
                  index,
                  "courseSections",
                  selected?.name,
                  "syllabusName",
                  true
                );
                handleInputChange(
                  index,
                  "courseSections",
                  selected?.id,
                  "syllabusId",
                  true
                );
              }}
            >
              <option value="">Select Syllabus</option>
              {syllabusList.map((syllabus) => (
                <option key={syllabus.id} value={syllabus.id}>
                  {syllabus.name}
                </option>
              ))}
            </select>
          </div>
        )} */}
        <div className="">
          {/* <div className="">
            <h3>Main Title</h3>
            <div className="form-inline">
              <input
                type="text"
                name="courseSections"
                placeholder={`Add section main title`}
                value={section?.mainTitle}
                onChange={({ target }) =>
                  handleInputChange(index, target.name, target.value, "mainTitle", true)
                }
              />
            </div>
          </div> */}
          <div className="">
            <h4>Section {index + 1} - Title</h4>
            <div className="form-inline">
              {/* <input
                type="text"
                name="courseSections"
                placeholder={`Add section ${index + 1} title`}
                value={section?.name}
                onChange={({ target }) =>
                  handleInputChange(index, target.name, target.value, "name", true)
                }
              /> */}
              <select className="form-control !mt-2" value={section?.name} name="courseSections"
                onChange={({ target }) =>
                  handleInputChange(index, target.name, target.value, "name", true)
                }
              >
                <option value="">Select Syllabus</option>
                {syllabusList?.map((syllabus, idx) => (
                  <option key={syllabus.id || idx} value={syllabus.name}>
                    {syllabus.name}
                  </option>
                ))}
              </select>
            </div>

            {(current === 18 || location1 === "courseEdit") && (
              <div className="section-description">
                <h4>Section {index + 1} - Description</h4>
                <TextEditor
                  formState={section?.description}
                  history={history}
                  handleEditorStateChange={handleEditorStateChange(
                    "courseSections",
                    "description",
                    index
                  )}
                />
              </div>
            )}
            {location === "createBundle" && (
              <div className="section-description">
                <h4>Section {index + 1} - Description</h4>
                <TextEditor
                  formState={section?.description}
                  history={history}
                  handleEditorStateChange={handleEditorStateChange(
                    "courseSections",
                    "description",
                    index
                  )}
                />
              </div>
            )}

            <div className="form-inline section-description">
              <h4>Section {index + 1} - Video/Document Link</h4>
              <input
                type="text"
                name="courseSections"
                placeholder="Video/Document Link"
                value={section?.videoLink}
                onChange={({ target }) =>
                  handleInputChange(
                    index,
                    target.name,
                    target.value,
                    "videoLink",
                    true
                  )
                }
              />
            </div>
            <div className="define-add-text">
              <a
                name={index}
                href="javascript(void);"
                onClick={handleAddCourseMaterial}
              >
                + Add Course Material
              </a>
            </div>
            {isActive && (
              <div className="chapter-section">
                <div className="course-image-introductionSection">
                  <CourseFile
                    courseFileLimit={5}
                    courseFile={courseFile}
                    courseId={
                      location.state ? location.state.courseId : 0
                    }
                  />
                </div>
              </div>
            )}
          </div>
          <div id="align-image">
            {index > 0 ? (
              <img
                name="courseSections"
                href="javascript(void);"
                className=""
                onClick={(event) =>
                  removeFormFields(event, index, event.target.name)
                }
                src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                alt=""
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
